import { PET_INSURANCE_SELECTOR_ID } from "./pet-insurance-selector.3a2501b9861a.js";
import {
  OpenInsuranceSelectorEvent,
  InsuranceSelectorChangedEventType,
} from "../../js/insurance-selector-events.b006bae191bd.js";
import { Toast } from "../../js/toast.4272c7c2429f.js";

// "Patient return" flow: re-collect insurance info when loading the page
// from a share button-generated URL (patient-return=1 param)
const urlParams = new URLSearchParams(window.location.search);
if (urlParams.get("patient-return") === "1") {
  const pageConfigElement = document.getElementById("page-config");
  const pageConfig = pageConfigElement
    ? JSON.parse(pageConfigElement.textContent)
    : {};

  if (pageConfig.insuredVariant !== "insurance-cost-share") {
    document.dispatchEvent(
      new OpenInsuranceSelectorEvent(false, {
        navMethod: "patient-return",
      }),
    );
  }
}

const locationSelectors = document.querySelectorAll("pet-location-selector");
locationSelectors.forEach((selector) => {
  selector.addEventListener("change", (e) => {
    const url = new URL(window.location.href);
    url.searchParams.set("location", e.target.value);
    window.location.href = url.toString();
  });
});

document.addEventListener("change", (e) => {
  if (e.target.id === PET_INSURANCE_SELECTOR_ID) {
    const url = new URL(window.location.href);
    url.searchParams.set("plan", e.target.value);
    window.location.href = url.toString();
  }
});

document.addEventListener("click", (e) => {
  const button = e.target.closest("[data-action='open-insurance-dialog']");
  if (button) {
    document.dispatchEvent(
      new OpenInsuranceSelectorEvent(false, {
        navMethod: "cost-summary-button",
      }),
    );
  }
});

document.addEventListener("click", async (e) => {
  const button = e.target.closest("[data-action='share-estimate']");
  if (button) {
    const toast = new Toast();
    try {
      const pageConfigElement = document.getElementById("page-config");
      const pageConfig = pageConfigElement
        ? JSON.parse(pageConfigElement.textContent)
        : {};

      const url = new URL(window.location.href);

      // When insurance-cost-share users share a link, store that information on the URL
      // so we can prompt the member info form open when the link is visited
      if (pageConfig.insuredVariant === "insurance-cost-share") {
        url.searchParams.set("patient-return", "1");
      }

      await navigator.clipboard.writeText(url.toString());
      toast.showToast();
    } catch (error) {
      toast.showToast("Failed to copy link to clipboard", true);
    }
  }
});

document.addEventListener("click", (e) => {
  const insuranceCta = e.target.closest("[data-insurance-cta]");
  if (insuranceCta) {
    document.dispatchEvent(
      new OpenInsuranceSelectorEvent(false, {
        navMethod: "insurance-cta",
      }),
    );
  }
});

/*
  When an insurance selection changes after a successful interaction with
  the insurance selection dialog, we re-fetch the current details page.

  Due to the responsive layout we have multiple `name=plan` fields on the page,
  so we need this script to upsert the selected plan

  The basic flow is:
    1. User interacts with insurance selector dialog
    2. Dialog posts insurance details to /insurance-member/
    3. Server responds with HX-Trigger header containing one of these events:
      - tqc-plan-selected
      - tqc-benefits-confirmed
      - etc.
    4. insurance-selector.js receives that event and dispatches InsuranceSelectorChangedEvent
    5. HTMX in cost_summary.html listens for tqc:insurance-selector:changed from:body
    6. HTMX triggers GET to the current page
    7. This script configures the request parameters correctly before the request goes out
*/
document.body.addEventListener("htmx:configRequest", (htmxEvent) => {
  if (
    htmxEvent.detail.triggeringEvent?.type === InsuranceSelectorChangedEventType
  ) {
    // Grab plan id from the insurance selector event, not the htmx event
    //  (htmx has an array with multiple plan values, due to the multiple plan fields)
    delete htmxEvent.detail.parameters.plan;
    const selectedPlanId = htmxEvent.detail.triggeringEvent.detail.planId;

    const url = new URL(htmxEvent.detail.path, window.location.origin);
    url.searchParams.set("plan", selectedPlanId);

    // Mutate the URL htmx will fetch
    htmxEvent.detail.path = url.pathname + url.search;
  }
});

const downloadEstimateButtons = document.querySelectorAll(
  "[data-action='download-estimate']",
);
downloadEstimateButtons.forEach((button) => {
  button.addEventListener("click", () => {
    window.print();
  });
});
